import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import BattleUtils from "../../gzp/BattleUtils";
import { BootScene } from "../BootScene";

export class AdversaryAvatarContainer extends Phaser.GameObjects.Container {

    private static SCROLLING_SPEED = 40;

    private avatarID: number;
    private upperAvatarImage: Phaser.GameObjects.Image;
    private lowerAvatarImage: Phaser.GameObjects.Image;
    private adversarySelected: boolean;
    private setToStop: boolean;
    private stopScrolling: boolean;
    private playerNameLabel: Phaser.GameObjects.Text;
    private maskShape: Phaser.GameObjects.Graphics;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = 200;

        this.adversarySelected = false;
        this.setToStop = false;
        this.stopScrolling = false;

        this.avatarID = Math.floor(Math.random() * 5) + 1;

        this.upperAvatarImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "avatar-gamezop-3");
        this.add(this.upperAvatarImage);

        this.avatarID = this.getAvatarID();

        this.lowerAvatarImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "avatar-gamezop-3");
        this.add(this.lowerAvatarImage);
        // this.loadOpponentProfilePic(this.upperAvatarImage);
        // this.loadOpponentProfilePic(this.lowerAvatarImage);

        this.maskShape = new Phaser.GameObjects.Graphics(this.scene);
        this.maskShape.y = GameConstants.GAME_HEIGHT / 2;
        this.maskShape.fillStyle(0xFF0000);
        this.maskShape.fillRect(-50, -50, 100, 100);
        this.maskShape.scaleY = GameVars.scaleY;

        const mask = this.maskShape.createGeometryMask();
        this.upperAvatarImage.setMask(mask);
        this.lowerAvatarImage.setMask(mask);

        const adversaryFrame = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "icon_basic_frame");
        this.add(adversaryFrame);

        this.playerNameLabel = new Phaser.GameObjects.Text(this.scene, 0, -80 + (BootScene.textYgap * 64), GameVars.playerData.name + "\n", { fontFamily: "Teko-Medium", fontSize: "30px", color: "#FFFFFF" });
        this.playerNameLabel.visible = false;
        this.playerNameLabel.setShadow(0, 3, "#061f55", 0, false, true);
        this.playerNameLabel.setOrigin(.5,BootScene.originY);
        this.add(this.playerNameLabel);
    }

    public update(): void {

        this.maskShape.x = this.x + GameConstants.GAME_WIDTH / 2;

        if (this.stopScrolling) {
            return;
        }

        this.lowerAvatarImage.y += AdversaryAvatarContainer.SCROLLING_SPEED;
        this.upperAvatarImage.y = this.lowerAvatarImage.y - 100;

        if (this.lowerAvatarImage.y >= 100) {

            if (this.setToStop) {
                console.log(" animation stopped :> ");
                this.stopScrolling = true;
                this.upperAvatarImage.y = 0;

                this.playerNameLabel.visible = true;
                this.playerNameLabel.text = GameVars.adversaryData.name + "\n";

            } else {

                const tmpAvatarImage = this.lowerAvatarImage;
                this.lowerAvatarImage = this.upperAvatarImage;
                this.upperAvatarImage = tmpAvatarImage;

                if (this.adversarySelected) {
                    this.upperAvatarImage.setFrame("avatar-gamezop-3");
                    this.loadOpponentProfilePic(this.upperAvatarImage);
                    this.setToStop = true;
                } else {
                    this.avatarID = this.getAvatarID();
                    this.upperAvatarImage.setFrame("avatar-gamezop-" + this.avatarID);
                }
            }
        }
    }

    public onAdversaryJoined(): void {

        this.adversarySelected = true;
    }

    private getAvatarID(): number {

        let avatarID = Math.floor(Math.random() * 5) + 1;

        while (avatarID === this.avatarID) {
            avatarID = Math.floor(Math.random() * 5) + 1;
        }

        return avatarID;
    }

    private loadOpponentProfilePic(opponentAvatar: Phaser.GameObjects.Image) {
        if (!BattleUtils.battleOpponentData.photo) {
            console.warn("Profile picture not available, Opponent");
            opponentAvatar.setTexture("texture_atlas_1", "avatar-gamezop-3");
            return;
        }
        const loader = new Phaser.Loader.LoaderPlugin(this.scene);
        const cachekey = "opponentCache" + Math.floor(Math.random() * 1000);
        BattleUtils.opponentProfileCache = cachekey;
        loader.image(cachekey, BattleUtils.getValidLoadUrl(BattleUtils.battleOpponentData.photo));
        loader.once("filecomplete", (key) => {
            opponentAvatar.setTexture(cachekey);
            opponentAvatar.displayHeight = 100;
            opponentAvatar.displayWidth = 100;
        });
        loader.once("loaderror", (e) => {
            console.log("Image load error, fallback to defautl");
            BattleUtils.opponentProfileCache = undefined;
            opponentAvatar.setTexture("texture_atlas_1", "avatar-gamezop-3");
        });
        loader.crossOrigin = "anonymous";
        loader.start();
    }
}
